/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_map_controls__aria_labels__access_profile = /** @type {(inputs: {}) => string} */ () => {
	return `Zu meinem Profil`
};

const en_map_controls__aria_labels__access_profile = /** @type {(inputs: {}) => string} */ () => {
	return `Go to my profile`
};

const es_map_controls__aria_labels__access_profile = /** @type {(inputs: {}) => string} */ () => {
	return `Acceder a mi perfil`
};

const fr_map_controls__aria_labels__access_profile = /** @type {(inputs: {}) => string} */ () => {
	return `Accéder à mon profil`
};

const it_map_controls__aria_labels__access_profile = /** @type {(inputs: {}) => string} */ () => {
	return `Accesso al mio profilo`
};

const nl_map_controls__aria_labels__access_profile = /** @type {(inputs: {}) => string} */ () => {
	return `Mijn profiel openen`
};

const pt_map_controls__aria_labels__access_profile = /** @type {(inputs: {}) => string} */ () => {
	return `Aceder ao meu perfil`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__access_profile = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.map_controls__aria_labels__access_profile(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("map_controls__aria_labels__access_profile", locale)
	if (locale === "de") return de_map_controls__aria_labels__access_profile(inputs)
	if (locale === "en") return en_map_controls__aria_labels__access_profile(inputs)
	if (locale === "es") return es_map_controls__aria_labels__access_profile(inputs)
	if (locale === "fr") return fr_map_controls__aria_labels__access_profile(inputs)
	if (locale === "it") return it_map_controls__aria_labels__access_profile(inputs)
	if (locale === "nl") return nl_map_controls__aria_labels__access_profile(inputs)
	return pt_map_controls__aria_labels__access_profile(inputs)
};